import { NotificationsPage } from './notifications.page';

// Pages must be default exports for lazy loading
// eslint-disable-next-line import/no-default-export
export default NotificationsPage;
